export default __webpack_public_path__ + "static/media/Guild Wars Illustration.965115e7.png";